import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './snackbarSlice';
import profileReducer from './profileSlice';

const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    profile: profileReducer,
    // Add other reducers here
  },
});

export default store;
